import { useState } from "react";

import Suspense from "components/shared/Suspense";

import LogoutLinkActive from "./LogoutLinkActive";
import LogoutLinkInactive from "./LogoutLinkInactive";

export default function LogoutLink() {
  const [clicked, setClicked] = useState(false);

  // Don't load Headless UI and the entire dropdown component unless it's clicked on
  if (clicked) {
    return (
      <Suspense fallback={<LogoutLinkInactive loading />}>
        <LogoutLinkActive />
      </Suspense>
    );
  }

  return <LogoutLinkInactive onClick={() => setClicked(true)} />;
}
